/**
 * 比对告警API
 * 
 * @Author:szs
 * @Date: 2021-05-25
 * @Last Modified time: 2021-05-25
 */

import http from '@/utils/request';
const apis = {

  // 获取比对告警列表
  getConfigComparisonList(dto) {
    return http.get({
      url: '/pc/configComparison/getConfigComparisonList',
      data: dto
    });
  },

  // 获取比对告警
  getConfigComparison(dto) {
    return http.get({
      url: '/pc/configComparison/getConfigComparison',
      data: dto
    });
  },

  // 保存比对告警
  saveConfigComparison(dto) {
    return http.post({
      url: '/pc/configComparison/saveConfigComparison',
      data: dto
    });
  },

  // 删除比对告警
  delConfigComparison(id) {
    return http.post({
      url: '/pc/configComparison/delConfigComparison',
      data: {
        id: id,
        _method: 'delete'
      }
    })
  },

  // 获取比对告警实时数据
  getConfigComparisonData(dto) {
    return http.get({
      url: '/pc/configComparison/getConfigComparisonData',
      data: dto
    });
  },


}
export default apis